// Auto generated file, do not manually modify!
// com.hotpads.admanagement.api.web.external.handler.AdManagementUserSalesforceApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo,
  AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo_Path,
} from '@zg-rentals/ts-ad-management-client';

import type { AdManagementSalesProMappingDto } from '@zg-rentals/ts-ad-management-client';

export type AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo_Options = UseQueryOptions<
  Array<AdManagementSalesProMappingDto>,
  unknown,
  Array<AdManagementSalesProMappingDto>,
  readonly [string]
>;

const AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo_GetKey = () =>
  [AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo_Path] as const;

export const AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo_GetKey(),
    queryFn: () => AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Return Logged in User's Sales Pros' Name(s) and Email(s), as well as customerIds, zrns and SFAccountNames
 */
export const useAdManagementUserSalesforceApiHandler_getUserAndSalesProInfo = ({
  httpClient,
  ...options
}: Omit<AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo_queryOptions({ httpClient }),
    ...options,
  });
};
useAdManagementUserSalesforceApiHandler_getUserAndSalesProInfo.getKey =
  AdManagementUserSalesforceApiHandler_getUserAndSalesProInfo_GetKey;
